Ext.define('SA.PointsLimitInterval', {
    constructor({limit, used, proposedUse}) {
        this.limit = limit;
        this.usedPercent = (used / limit) * 100;
        this.wouldBeUsed = used + proposedUse;
        this.wouldBeUsedPercent = ((used + proposedUse) / limit) * 100;
    },

    isBeyondLimit() {
        return this.wouldBeUsedPercent > 100;
    },

    serialize() {
        var {limit, usedPercent, wouldBeUsed, wouldBeUsedPercent} = this;

        return {limit, usedPercent, wouldBeUsed, wouldBeUsedPercent};
    }
});